// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import finEntity from './entities/fin.json';
import finMenu from '../pages/fin/menu.json';
import finFullForm from '../pages/fin/forms/full.json';
import finContextForm from '../pages/fin/forms/context.json';
import finMiniForm from '../pages/fin/forms/mini.json';
import finLookupForm from '../pages/fin/forms/lookup.json';
import finTableView from '../pages/fin/views/table.json';
import finStagesView from '../pages/fin/views/stages.json';
import finCardsView from '../pages/fin/views/cards.json';
import finInlineView from '../pages/fin/views/inline.json';
import finBacklogView from '../pages/fin/views/backlog.json';
import finSplitView from '../pages/fin/views/split.json';
import finCalendarView from '../pages/fin/views/calendar.json';
import finDashboardView from '../pages/fin/views/dashboard.json';

/** Тип запису «Внесок» зі сторінками пакета: меню, форми та подання з pages/fin/. */
export const finDefinition: IRecordTypeDefinition = {
  ...finEntity,
  views: assembleViewSet({
      table: finTableView,
      stages: finStagesView,
      cards: finCardsView,
      inline: finInlineView,
      backlog: finBacklogView,
      split: finSplitView,
      calendar: finCalendarView,
      dashboard: finDashboardView,
  }),
  form: finFullForm,
  forms: { full: finFullForm, context: finContextForm, mini: finMiniForm, lookup: finLookupForm },
  menu: finMenu,
} as IRecordTypeDefinition;
